angular.module('app').directive('trsDetailMain', function(){
    return {
        scope: true,
        restrict: 'AE',
        templateUrl: './resourceCenter/directive/trsDetailMain/trsDetailMain_tpl.html',
        replace: true,
        link: function($scope, iElm, iAttrs, controller) {
            $scope.switchPic = function() {
               
            };

        }
    };
});
